module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/ms-icon-150x150-f1c379d4c937f99d0e35efa745d07672.png";